import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import { ConfigComponent } from '@sobrus-com/sobrus-design-system-v2';
import '@sobrus-com/sobrus-posts-package/dist/style.css';

import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Root element not found');

// Reload once automatically when a dynamic import fails due to a new deployment
window.addEventListener('vite:preloadError', () => {
	const alreadyReloaded = sessionStorage.getItem('chunk_reload_attempt') === 'true';
	if (!alreadyReloaded) {
		sessionStorage.setItem('chunk_reload_attempt', 'true');
		window.location.reload();
	}
});

ReactDOM.createRoot(rootElement).render(
	<React.StrictMode>
		<Suspense fallback="">
			<ConfigComponent
				solution="sns"
				fonts={{
					fontFamily:
						'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;',
				}}
			>
				<App />
			</ConfigComponent>
		</Suspense>
	</React.StrictMode>
);
